import {useDebugValue} from 'react';

import {useSettings} from './';

const defaultSettings = {
    hasLoaded: false,
    isSubmitting: false,
    hasSubmitted: false,
    hasSubmittedSuccessfully: false,
    wasLastSubmittedSuccessfully: false
};

function useFormSettings(props) {
    const {
        formSettings: propsSettings
    } = props;

    const {
        initialSettings,
        settings,
        changeSettings
    } = useSettings(defaultSettings, propsSettings);

    const result = {
        initialSettings,
        settings,
        changeSettings
    };

    useDebugValue(result);

    return result;
}

export {useFormSettings};
